const all = ['doctolibPendingChanges']
const detail = (id?: string) => [...all, id]

export const doctolibPendingChangesKeys = { all, detail }
